// Metronic

// Imports
import Swal from 'sweetalert2';
window.swal = Swal;

import { marked } from 'marked';
marked.use( {
  mangle: false,
  headerIds: false,
} );
window.marked = marked;

// Global
window.jQuery = window.$ = require( 'jquery' );
require( 'jquery-ui-dist/jquery-ui.js' );
import 'jquery-ui-dist/jquery-ui.css';
window.Popper = require( '@popperjs/core' );
window.bootstrap = require( 'bootstrap' );
require( 'jquery-migrate' );
jQuery.migrateMute = true;
jQuery.migrateTrace = false;
window.serializeJSON = require( 'jquery-serializejson' );

// Sweetalert2
require( 'es6-promise-polyfill/promise.min.js' );

// jstree
require( 'jstree' );
import 'jstree/dist/themes/default/style.css';

// Bootstrap Maxlength
require( 'bootstrap-maxlength' );

// select2
require( 'select2' );

// Devbridge Autocomplete
require( 'devbridge-autocomplete' );

// jQuery Inputmask
require( 'inputmask/dist/jquery.inputmask.min.js' );

// Bootstrap Rating
require( 'bootstrap-rating' );

// Momentjs
window.moment = require( 'moment' );

// Sentry
window.Sentry = require( '@sentry/browser' );

// jQuery Validation
require( 'jquery-validation' );
require( 'jquery-validation/dist/additional-methods.js' );

// Dual-listbox
import { DualListbox } from "dual-listbox/src/dual-listbox";
window.DualListbox = DualListbox;
import 'dual-listbox/dist/dual-listbox.css';

// Mjml
import mjml from 'mjml-browser';
window.mjml2html = mjml;

// @yaireo/tagify
import Tagify from '@yaireo/tagify';
window.Tagify = Tagify;

// Fonts
import '@fortawesome/fontawesome-free/css/all.min.css';
